const timeToNumber = (time: string | undefined) => {
  if (typeof time === "number") {
    return time;
  }

  if (time) {
    return +time.replace(" s", "");
  }

  return 0;
};

export default timeToNumber;
